'use strict';

/* eslint-disable no-undef */

var formValidation = require('app_custom_mufe/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');

module.exports = {
    submitContactuS: function () {
        $('form.contact-us').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                    $.spinner().stop();
                }
            });
            return false;
        });
    },

    handleFormationsAndSessionsSelection: function () {
        var $sessionSelection = $('#sessionSelection');
        var allSessionItems = $sessionSelection.find('.session-item').clone();

        var defaultOption = Resources.CONTACT_CHOOSE_OPTION;

        $sessionSelection.empty().append('<option value="">' + defaultOption + '</option>');

        $('#trainingSelection').on('change', function () {
            var selectedTraining = $(this).val();

            $sessionSelection.empty();
            $sessionSelection.append('<option value="">' + defaultOption + '</option>');

            if (selectedTraining) {
                allSessionItems.filter('[data-parent="' + selectedTraining + '"]').each(function() {
                    $sessionSelection.append($(this));
                });
                $sessionSelection.prop('disabled', false);
            } else {
                $sessionSelection.prop('disabled', true);
            }
        });
    }
};